import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import "../stiluri/Reintegrare.css";
import html2pdf from "html2pdf.js";

const Reintegrare = () => {
  const { id } = useParams();
  const [beneficiar, setBeneficiar] = useState(null);
  const [sansa, setSansa] = useState(null);
  const [explicatie, setExplicatie] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const db = getFirestore();
  const [intrebare, setIntrebare] = useState("");
  const [raspunsGPT, setRaspunsGPT] = useState("");
  const [loadingGPT, setLoadingGPT] = useState(false);
  const exportToPDF = () => {
    const element = document.getElementById("reintegrare-pagina");

    const opt = {
      margin: 0.5,
      filename: `${beneficiar.nume || "export"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };
  const calculeazaSanse = (b) => {
    let sansa = 50; // start din mijloc

    // Nivel studii
    switch (b.Nivel_Studii) {
      case "Licență":
        sansa += 10;
        break;
      case "Master":
        sansa += 15;
        break;
      case "Doctorat":
        sansa += 20;
        break;
      default:
        sansa -= 5;
    }

    // Consum alcool
    if (b.consum_alcool === "Nu consumă") sansa += 15;
    else if (b.consum_alcool === "Ocazional") sansa += 5;
    else sansa -= 15;

    // Consum droguri
    if (b.consum_droguri === "Frecvent") sansa -= 30;
    else if (b.consum_droguri === "Ocazional") sansa -= 10;
    else sansa += 10;

    // Stare autonomie
    switch (b.stare_autonomie) {
      case "Total autonom":
        sansa += 20;
        break;
      case "Parțial autonom":
        sansa += 5;
        break;
      case "Total dependent":
        sansa -= 20;
        break;
      default:
        sansa += 0;
    }

    // Comportament agresiv
    if (b.comportament_agresiv === "Da") sansa -= 25;
    else sansa += 10;

    // Status HIV
    if (b.status_hiv === "Pozitiv") sansa -= 15;
    else sansa += 10;

    // Status TBC
    if (b.status_tbc === "Pozitiv") sansa -= 15;
    else sansa += 5;

    // Diagnostic medical
    if (b.diagnostic_medical) {
      const boli_critice = ["Cancer", "Tuberculoză", "SIDA"];
      sansa -= boli_critice.some((x) => b.diagnostic_medical.includes(x))
        ? 20
        : 0;
    }

    // Istoric angajari
    if (b.istoric_angajari === "Lucrat 4-6 ani") sansa += 20;
    else if (b.istoric_angajari === "Lucrat 1-3 ani") sansa += 10;
    else sansa -= 10;

    // Durata somajului
    if (b.durata_somajului > 12) sansa -= 20;
    else if (b.durata_somajului > 6) sansa -= 10;
    else sansa += 10;

    // Debite financiare
    if (b.debite > 5000) sansa -= 25;
    else if (b.debite > 1000) sansa -= 10;
    else sansa += 15;

    // Venit lunar
    if (b.venit_lunar > 3000) sansa += 15;
    else if (b.venit_lunar > 1500) sansa += 5;
    else sansa -= 10;

    // Istoric penal
    if (b.istoric_penal === "Da") sansa -= 25;
    else sansa += 10;

    // Procese în curs
    if (b.procese_curs === "Da") sansa -= 10;
    else sansa += 5;

    // Psihologic
    if (b.coping === "Scăzut") sansa -= 20;
    else sansa += 10;

    if (b.trairi_emotionale === "Negative") sansa -= 15;
    else sansa += 10;

    if (b.traume_anterioare) sansa -= 10;

    // Social
    if (b.acces_sprijin_social === "Beneficiază") sansa += 20;
    else sansa -= 15;

    // Stabilitate locativa
    if (b.stabilitate_locativa === "Fără locuință") sansa -= 30;
    else sansa += 10;

    // Accepta asistenta
    if (b.accepta_asistenta === "Da") sansa += 15;
    else sansa -= 10;

    // Normalizează scorul final între 0 și 100
    if (sansa < 0) sansa = 0;
    if (sansa > 100) sansa = 100;

    return Math.round(sansa);
  };

  const explicaSanse = (b) => {
    const motive = [];

    if (b.consum_droguri === "Frecvent") {
      motive.push(
        "Consumul frecvent de droguri afectează negativ reintegrarea. Recomandăm sprijin specializat pentru reducerea consumului."
      );
    } else if (b.consum_droguri === "Ocazional") {
      motive.push(
        "Consum ocazional de droguri poate afecta șansele. Limitarea consumului este recomandată."
      );
    }

    if (b.comportament_agresiv === "Da") {
      motive.push(
        "Comportamentul agresiv este un factor de risc. Consilierea psihologică poate ajuta la gestionarea acestuia."
      );
    }

    if (b.consum_alcool === "Ocazional" || b.consum_alcool === "Frecvent") {
      motive.push(
        "Consumul de alcool poate afecta procesul de reintegrare. Limitarea consumului este recomandată."
      );
    }

    if (b.istoric_penal === "Da") {
      motive.push(
        "Există antecedente penale, ceea ce poate complica reintegrarea. Respectarea legii este esențială."
      );
    }

    if (
      b.stare_autonomie === "Total dependent" ||
      b.stare_autonomie === "Parțial autonom"
    ) {
      motive.push(
        "Nivelul redus de autonomie afectează șansele. Îmbunătățirea autonomiei prin suport și terapii este recomandată."
      );
    }

    if (b.stabilitate_locativa === "Fără locuință") {
      motive.push(
        "Lipsa unei locuințe stabile reduce șansele de reintegrare. Accesul la locuințe sociale sau programe de suport poate ajuta."
      );
    }

    if (b.coping === "Scăzut") {
      motive.push(
        "Capacitatea redusă de a face față stresului este un impediment. Participarea la consiliere psihologică este recomandată."
      );
    }

    if (b.traume_anterioare) {
      motive.push(
        "Traumele anterioare nerezolvate pot afecta negativ procesul de reintegrare. Terapia specializată poate ajuta."
      );
    }

    if (b.acces_sprijin_social !== "Beneficiază") {
      motive.push(
        "Lipsa accesului la sprijin social reduce șansele. Se recomandă accesarea serviciilor sociale disponibile."
      );
    }

    if (b.venit_lunar && b.venit_lunar < 1500) {
      motive.push(
        "Venitul lunar scăzut poate limita resursele pentru reintegrare. Creșterea venitului sau accesul la suport financiar poate ajuta."
      );
    }

    if (motive.length === 0) {
      return "Profilul este favorabil reintegrării. Continuă pe această cale!";
    } else {
      return (
        "Factorii care reduc șansele sunt:\n- " +
        motive.join("\n- ") +
        "\nPentru a crește șansele, te sfătuim să lucrezi pe aceste aspecte."
      );
    }
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const docRef = doc(db, "Beneficiari", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setBeneficiar(docSnap.data());
          setSansa(null);
          setExplicatie("");
        } else {
          setError("Beneficiarul nu a fost găsit.");
        }
      } catch (err) {
        setError("A apărut o eroare la preluarea datelor.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [id, db]);

  const handleCalculeazaClick = () => {
    if (beneficiar) {
      const scor = calculeazaSanse(beneficiar);
      setSansa(scor);
      const textExplicativ = explicaSanse(beneficiar);
      setExplicatie(textExplicativ);
    }
  };

  const trimiteLaChatGPT = async (retryCount = 0) => {
    setLoadingGPT(true);
    setRaspunsGPT("");

    try {
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 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`,
          },
          body: JSON.stringify({
            model: "gpt-3.5-turbo",
            messages: [{ role: "user", content: intrebare }],
          }),
        }
      );

      if (response.status === 429 && retryCount < 3) {
        // Așteaptă 1 secundă și încearcă din nou
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return trimiteLaChatGPT(retryCount + 1);
      }

      const data = await response.json();

      if (data.error) {
        console.error("Eroare API:", data.error);
        setRaspunsGPT(`Răspuns invalid de la API: ${data.error.message}`);
      } else {
        setRaspunsGPT(data.choices[0].message.content);
      }
    } catch (error) {
      setRaspunsGPT("A apărut o eroare la generarea răspunsului.");
      console.error(error);
    } finally {
      setLoadingGPT(false);
    }
  };
  const exportToXML = () => {
    if (!beneficiar) return;

    const xmlContent = `
  <beneficiar>
    ${Object.entries(beneficiar)
      .map(([key, value]) => {
        if (typeof value === "object") {
          return `<${key}>${Object.entries(value)
            .map(([k, v]) => `<${k}>${v}</${k}>`)
            .join("")}</${key}>`;
        } else {
          return `<${key}>${value}</${key}>`;
        }
      })
      .join("")}
  </beneficiar>
  `.trim();

    const blob = new Blob([xmlContent], { type: "application/xml" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `beneficiar_${id}.xml`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div id="reintegrare-pagina" className="detalii-grid">
      <h2>Social AI</h2>

      {loading && <p>Se încarcă datele beneficiarului...</p>}
      {error && <p className="eroare">{error}</p>}

      {beneficiar && (
        <div>
          <h3>Date beneficiar:</h3>
          <p>Nume: {beneficiar.nume}</p>
          <p>Prenume: {beneficiar.prenume}</p>
          <p>CNP: {beneficiar.cnp}</p>
          {/* Alte date relevante */}

          <button onClick={handleCalculeazaClick}>Calculează șanse</button>

          {sansa !== null && (
            <div className="rezultat">
              <h4>Șanse reintegrare: {sansa}%</h4>
              <pre>{explicatie}</pre>
            </div>
          )}
        </div>
      )}

      <div className="chatgpt-intrebare">
        <h4>Întreabă AI-ul (ChatGPT)</h4>
        <textarea
          rows={4}
          cols={50}
          placeholder="Scrie întrebarea ta aici..."
          value={intrebare}
          onChange={(e) => setIntrebare(e.target.value)}
        />
        <br />
        <button onClick={trimiteLaChatGPT} disabled={loadingGPT}>
          {loadingGPT ? "Se generează..." : "Trimite întrebarea"}
        </button>
        <button
          onClick={exportToXML}
          style={{
            marginTop: "20px",

            color: "white",
            padding: "10px 16px",
            borderRadius: "8px",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Exportă XML
        </button>
        <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
          <button
            onClick={exportToXML}
            style={{
              backgroundColor: "#2196F3",
              color: "white",
              padding: "10px 16px",
              borderRadius: "8px",
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Exportă XML
          </button>

          <button
            onClick={exportToPDF}
            style={{
              color: "white",
              padding: "10px 16px",
              borderRadius: "8px",
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Exportă PDF
          </button>
        </div>

        {raspunsGPT && (
          <div className="raspuns-gpt">
            <h5>Răspuns AI:</h5>
            <pre>{raspunsGPT}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reintegrare;
